<template>
	<div class="bg-gray-50">
		<ContainedSection
			:has-padding="false"
			:has-background="true"
			background-color="bg-white"
		>
			<TwoColumns
				:has-padding-first-column="true"
				first-column-class="order-last lg:order-none"
			>
				<template #first>
					<BreadcrumbNavigation :crumbs="crumbs" />

					<h1 class="mt-4 lg:mt-8">
						Flick the switch. Subscribe, finance or buy electric
						cars online
					</h1>
					<div class="mt-8 space-y-5 text-lg text-gray-575">
						<div>Subscribe now and buy later!</div>
						<div>
							An electric car subscription is an affordable and
							flexible alternative to buying an electric vehicle
							outright.
						</div>
						<div>
							Our range of quality electric cars could save you
							petrol and reduce your tailpipe emissions, helping
							you make a conscious choice when it comes to the
							environment and your bank account.
						</div>
						<div>
							Whether you want to drive an EV long term or just
							give it a go, trade in your petrol vehicle and flick
							the switch to electric today.
						</div>
					</div>
					<div class="mt-8 space-y-2">
						<div
							v-for="(list, key) in heroList"
							:key="key"
							class="flex flex-col"
						>
							<div>
								<CarbarButton
									:is-full-width="false"
									:is-outline="key !== 0"
									:is-mixed="true"
									@click="
										list.scrollTo
											? scrollTo(list.scrollTo)
											: navigateTo(list.linkTo)
									"
								>
									{{ list.label }}
								</CarbarButton>
							</div>
						</div>
					</div>
				</template>
				<template #second>
					<div class="h-full">
						<div class="flex h-full items-center">
							<CarbarImage
								image="img/electric-vehicle/hero-evsubs.webp"
								alt-text="Electric vehicles"
							/>
						</div>
					</div>
				</template>
			</TwoColumns>
		</ContainedSection>

		<ContainedSection id="what-is-car-subscription" :has-background="true">
			<ElectricCarsEverything />
		</ContainedSection>

		<ContainedSection
			id="sell-your-car-to-us"
			:has-background="true"
			:has-padding="false"
		>
			<SellYourCarToUs />
		</ContainedSection>

		<ContainedSection id="what-is-ev-subscription" :has-background="true">
			<WhatIsEvSubscription />
		</ContainedSection>

		<ContainedSection id="novated-ev-subscriptions" :has-background="true">
			<NovatedEvSubscription />
		</ContainedSection>

		<ContainedSection>
			<ElectricVehciclesFaqs />
		</ContainedSection>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import BreadcrumbNavigation from '@/components/breadcrumbs/BreadcrumbNavigation.vue'
import ElectricVehciclesFaqs from '@/components/electric-vehicles/ElectricVehciclesFaqs.vue'
import SellYourCarToUs from '@/components/electric-vehicles/SellYourCarToUs.vue'
import WhatIsEvSubscription from '@/components/electric-vehicles/WhatIsEvSubscription.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import ElectricCarsEverything from '@/components/electric-vehicles/ElectricCarsEverything.vue'
import NovatedEvSubscription from '@/components/electric-vehicles/NovatedEvSubscription.vue'

const heroList = [
	{
		label: 'Trade in and upgrade to an electric vehicle',
		scrollTo: '#sell-your-car-to-us',
	},
	{
		label: 'What is an EV car subscription?',
		scrollTo: '#what-is-ev-subscription',
	},
	{
		label: 'Compare new or demo electric car deals',
		linkTo: '/compare-car-subscriptions-vs-leasing',
	},
]

const crumbs = [
	{
		title: 'Home',
		url: '/',
	},
	{
		title: 'Electric vehicles',
	},
]
</script>
